import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTypedSelector } from '../../hooks/useTypedSelector';
import { initialCity } from '../../modules/mapSearch/controllers/citySelect.controller';
import {
  setCityList,
  setSelectedCity,
} from '../../modules/mapSearch/redux/mapSearch.reducer';

function useSelectedCity() {
  const dispatch = useDispatch();
  const { cityList } = useTypedSelector((state: any) => state.mapSearch);
  useEffect(() => {
    const hasCityList = !!cityList.length;
    const userCities = hasCityList
      ? cityList
      : JSON.parse(
          sessionStorage.getItem('cities') || '[{"name": "São Paulo"}]'
        );
    const savedCity = JSON.parse(
      sessionStorage.getItem('defaultCity') || 'undefined'
    );
    const citySelected = initialCity({
      defaultCity: savedCity,
      cities: userCities,
    });
    if (!hasCityList) {
      dispatch(setCityList(userCities));
    }
    if (!citySelected) {
      dispatch(setSelectedCity(userCities[0]));
    }
    dispatch(setSelectedCity(citySelected));
  }, []);
}

export default useSelectedCity;
